// compound value in localStorage utils
function compoundValueKey(name) {
    return `${name}.key`;
}

function compoundValueTimestamp(name) {
    return `${name}.ts`;
}

function compoundValueAccessed(name) {
    return `${name}.accessed`;
}

export function setCompoundValue(name, value, ts) {
    const timestamp = Date.now().toString();
    window.localStorage.setItem(compoundValueKey(name), value);
    window.localStorage.setItem(compoundValueTimestamp(name), ts || timestamp);
    window.localStorage.setItem(compoundValueAccessed(name), timestamp);
}

export function getCompoundValue(name) {
    const value = window.localStorage.getItem(compoundValueKey(name));
    const timestamp = window.localStorage.getItem(compoundValueTimestamp(name));
    const accessed = window.localStorage.getItem(compoundValueAccessed(name));
    if (!value || !timestamp || isNaN(timestamp) || !accessed || isNaN(accessed)) return null;

    return {
        value,
        date: new Date(Number(timestamp)),
        accessed: new Date(Number(accessed)),
        full: `${value}.${timestamp}`
    };
}

export function refreshCompoundValue(name) {
    const timestamp = Date.now().toString();
    window.localStorage.setItem(compoundValueAccessed(name), timestamp);
}

export function removeCompoundValue(name) {
    window.localStorage.removeItem(compoundValueKey(name));
    window.localStorage.removeItem(compoundValueTimestamp(name));
    window.localStorage.removeItem(compoundValueAccessed(name));
}
